import { Box, IconButton, Typography, useTheme } from '@mui/material';
import React from 'react';
import { ArticleNavBar } from '../article/styles';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { beneficios } from '../../utils/data';
import HomeCard from '../../components/homecard/homecard';
import { verify } from '../../utils/common';

const Benefits: React.FC = () => {
    const navigate = useNavigate();
    const theme = useTheme();

    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    };

    const renderCards = () => {
        return beneficios.map((item) => (
            <HomeCard data={item} handleClick={handleCardClick} />
        ));
    };

    React.useEffect(() => {
        (async () => {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
                const isValid = await verify(currentToken);
                if (isValid.code) {
                    navigate("/unauthorized");
                }
            } else {
                navigate("/unauthorized");
            }
        })();
    }, [navigate]);

    return (
        <Box>
            <ArticleNavBar theme={theme}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBackIcon/>
                </IconButton>
                <Typography>
                    Servicios y Beneficios
                </Typography>
                <span></span>
            </ArticleNavBar>
            <Box m={5}>
                <Box>
                    {renderCards()}
                </Box>
            </Box>
        </Box>
    )
}

export default Benefits;